export const OFFER_TYPE_MIRAKL = 'MIRAKL'
export const OFFER_TYPE_SAE = 'SAE'
